import React from 'react';
import { FormattedMessage } from 'react-intl';

var styles = {
    contenedor: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        marginBottom: '4px',
        cursor: 'default',
    },
    dot: {
        width: '9px',
        height: '9px',
        borderRadius: '50%',
        backgroundColor: '#5AAC43',
        marginRight: '8px',
        flexShrink: 0,
    },
    texto: {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '14px',
        fontWeight: 400,
        color: '#6B6F82',
    },
};

export function formatFecha(isoString) {
    var d = new Date(isoString);
    var dia = String(d.getDate()).padStart(2, '0');
    var mes = String(d.getMonth() + 1).padStart(2, '0');
    var hh = String(d.getHours()).padStart(2, '0');
    var mm = String(d.getMinutes()).padStart(2, '0');
    return dia + '/' + mes + ' ' + hh + ':' + mm;
}

export function formatHora(isoString) {
    var d = new Date(isoString);
    var hh = String(d.getHours()).padStart(2, '0');
    var mm = String(d.getMinutes()).padStart(2, '0');
    return hh + ':' + mm;
}

export function calcularDuracion(inicio, fin) {
    return Math.round((new Date(fin) - new Date(inicio)) / 60000);
}

function UltimaActualizacion(props) {
    var inicio = props.inicioProceso;
    var fin = props.finProceso;
    var pendiente = props.pendiente;

    if (!inicio || !fin || pendiente) return null;

    var duracion = calcularDuracion(inicio, fin);
    var texto = formatFecha(inicio) + ' — ' + formatHora(fin) + ' (' + duracion + ' min)';

    return (
        <div style={styles.contenedor}>
            <span style={styles.dot} />
            <span style={styles.texto}>
                <FormattedMessage
                    id="integracion.ultima_sincronizacion"
                    defaultMessage="Última sincronización"
                />
                {': ' + texto}
            </span>
        </div>
    );
}

export default UltimaActualizacion;
